// Auto-generated by scripts/split_calculators.py — keeps deterministic oilfield formulas in per-category modules.
import { round, num, positive, toRad } from "./_common";
// eslint-disable-next-line no-unused-vars
const _imports_ok = { round, num, positive, toRad, annularCapacity, pipeCapacity };

import { annularCapacity, pipeCapacity } from "./drilling";
// ===== Category: casing =====
// --- Casing & Tubing ---
// =========================================================================
// CASING & TUBING
// =========================================================================

export function casingCapacity({ id, length }) {
  return pipeCapacity({ id, length });
}
export function tubingCapacity({ id, length }) {
  return pipeCapacity({ id, length });
}
export function annularVolume({ dh, dp, length }) {
  return annularCapacity({ dh, dp, length });
}

export function buoyancyFactor({ mw }) {
  const M = positive(num(mw, "Mud Weight"), "Mud Weight");
  const bf = 1 - (M / 65.5);
  return {
    result: round(bf, 4),
    unit: "(unitless)",
    formula: "BF = 1 − (MW / 65.5)",
    steps: [`BF = 1 − (${M}/65.5) = ${round(bf, 4)}`],
    inputs: { "MW (ppg)": M },
  };
}

export function shoeTrackVolume({ casingId, shoeTrackLength }) {
  const I = positive(num(casingId, "Casing ID"), "Casing ID");
  const L = positive(num(shoeTrackLength, "Shoe Track Length"), "Shoe Track Length");
  const v = (I * I / 1029.4) * L;
  return {
    result: round(v, 3),
    unit: "bbl",
    formula: "V = (ID² / 1029.4) × L",
    steps: [`(${I}²/1029.4) × ${L} = ${round(v, 3)} bbl`],
    inputs: { "Casing ID (in)": I, "Shoe Track (ft)": L },
  };
}

// --- v1.4 — Casing & Completion additions ---
// ----- Casing & Completion additions -----

export function buoyedWeight({ airWeight, mw, buoyancyFactor }) {
  // Accept either explicit BF or MW (one path computes BF from MW)
  const W = positive(num(airWeight, "Air Weight"), "Air Weight");
  let bf;
  if (buoyancyFactor !== "" && buoyancyFactor !== undefined && buoyancyFactor !== null) {
    bf = num(buoyancyFactor, "Buoyancy Factor");
    if (bf <= 0) throw new Error("Buoyancy factor must be > 0");
  } else if (mw !== "" && mw !== undefined && mw !== null) {
    const M = positive(num(mw, "Mud Weight"), "Mud Weight");
    bf = 1 - M / 65.5;
  } else {
    throw new Error("Provide either Buoyancy Factor or Mud Weight");
  }
  const bw = W * bf;
  return {
    result: round(bw, 1),
    unit: "lb",
    formula: "Buoyed Weight = Air Weight × BF   (BF = 1 − MW/65.5)",
    steps: [
      `BF = ${round(bf, 4)}`,
      `Buoyed Weight = ${W} × ${round(bf, 4)} = ${round(bw, 1)} lb`,
    ],
    inputs: { "Air Weight (lb)": W, "MW (ppg)": mw || "—", "BF used": round(bf, 4) },
  };
}

export function completionFluidVolume({ capacity, length }) {
  const C = positive(num(capacity, "Capacity"), "Capacity");
  const L = positive(num(length, "Length"), "Length");
  const v = C * L;
  return {
    result: round(v, 3),
    unit: "bbl",
    formula: "V = Capacity (bbl/ft) × Length (ft)",
    steps: [`V = ${C} × ${L} = ${round(v, 3)} bbl`],
    inputs: { "Capacity (bbl/ft)": C, "Length (ft)": L },
  };
}

export function tubingDisplacement({ displacementBblFt, length }) {
  const C = positive(num(displacementBblFt, "Displacement"), "Displacement");
  const L = positive(num(length, "Length"), "Length");
  const v = C * L;
  return {
    result: round(v, 3),
    unit: "bbl",
    formula: "Tubing Displacement = Disp (bbl/ft) × Length (ft)",
    steps: [`V = ${C} × ${L} = ${round(v, 3)} bbl`],
    inputs: { "Displacement (bbl/ft)": C, "Length (ft)": L },
  };
}


